import { DataGridPremiumProps, GridColDef } from "@mui/x-data-grid-premium";
import * as React from "react";

import DataTable from "../table";

import { styled } from "@mui/material";
import { useAppSelector } from "../../../Redux/redux-store";
import { GetSelectedTabValue, GetTableVisibilityModel } from "../../../Redux/Reducers/redux-slice-new-request";

export interface GroupColumnTableProps extends DataGridPremiumProps {
  columns: (GridColDef & { groupBy?: string })[];
  onChangeExpandedGroup: (group: string) => void;
  isLoading?: boolean;
}

const GroupColumnTable: React.FC<GroupColumnTableProps> = (props) => {
  const { isLoading, rows = [], columns = [], onChangeExpandedGroup, ...otherProps } = props;

  const selectedTab = useAppSelector(GetSelectedTabValue);
  const tableVisibilityModel = useAppSelector(GetTableVisibilityModel);

  const _columns = React.useMemo(() => {
    return columns.map((col, index) => {
      const isGroupedBy = col && col.groupBy && col.groupBy.length > 0;
      const groupName = (isGroupedBy && col.groupBy) || "";

      const isExpanded = selectedTab === groupName || selectedTab === "all";

      const className = (isGroupedBy && isExpanded) || selectedTab === col.field ? "MuiColumn-ExpandedGroup" : "";

      return {
        ...col,
        headerClassName: className,
        cellClassName: className,
      };
    });
  }, [columns, selectedTab]);

  const onClickColumnHeader: DataGridPremiumProps["onColumnHeaderClick"] = React.useCallback(
    (column: { field: string; colDef: GroupColumnTableProps["columns"][0] }) => {
      if (column.colDef.groupBy) return;
      onChangeExpandedGroup(column.field);
    },
    [onChangeExpandedGroup]
  );

  return (
    <StyledDataTable
      noControls
      loading={isLoading}
      rows={rows}
      columns={_columns}
      columnHeaderHeight={48}
      rowHeight={56}
      onColumnHeaderClick={onClickColumnHeader}
      overrideColumnVisibility={tableVisibilityModel}
      pinnedColumns={{ left: ["placeHolderName"] }}
      {...otherProps}
    />
  );
};

export default GroupColumnTable;

const StyledDataTable = styled(DataTable)(({ theme, pagination }) => ({
  ".MuiColumn-ExpandedGroup": {
    background: theme.palette.backgroundAlpha.main,
  },
  ".MuiDataGrid-columnHeader": {
    height: 48,
    cursor: "pointer",
    "&:focus": {
      outline: "none",
    },
    "&:hover": {
      background: theme.palette.backgroundAlpha.main,
    },
  },
}));
